export default __webpack_public_path__ + "static/media/24.fedcb4cf.pdf";